import React, { Component } from 'react';
import { Button, Modal, Radio, Input, Spin } from 'antd';
import { TWO_FA_METHODS } from '../../../../redux/constants/two-fa';
import styles from './two-fa-modal.module.sass';
import check_icon from '../../../../assets/icons/check.svg';
import { STATUS } from '../../../../redux/constants';
import {
  showNotification,
  simpleErrorNotification,
} from '../../../../shared-components/Notifications';

const STEPS = {
  METHOD: 'METHOD',
  QR_CODE: 'QR_CODE',
  PIN_CODE: 'PIN_CODE',
  BACKUP_CODES: 'BACKUP_CODES',
  DONE: 'DONE',
};

class TwoFAModal extends Component {
  state = {
    step: STEPS.METHOD,
    selectedMethod: TWO_FA_METHODS.AUTHY,
    pin: '',
    showError: false,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.status !== STATUS.ERROR &&
      this.props.status === STATUS.ERROR
    ) {
      this.setState({ showError: true });
    }
  }

  handleMethodChange = (e) => {
    this.setState({ selectedMethod: e.target.value });
  };

  handlePinChange = (e) => {
    this.setState({ pin: e.target.value });
  };

  canProceed = () => {
    const { step, selectedMethod } = this.state;
    if (step === STEPS.METHOD) return !!selectedMethod;
    return true;
  };

  handleSubmit = () => {
    const { step, pin } = this.state;
    const orderedSteps = [
      STEPS.METHOD,
      STEPS.QR_CODE,
      STEPS.PIN_CODE,
      STEPS.DONE,
    ];
    const index = orderedSteps.indexOf(step);
    if (step === STEPS.METHOD) {
      this.props.load2faQR();
    }
    if (step === STEPS.PIN_CODE) {
      this.props.enable2fa(pin);
    }
    if (step === STEPS.DONE) {
      this.props.onFinish();
      return;
    }
    this.setState({ step: orderedSteps[index + 1] });
  };

  renderMethodSelector = () => {
    const { selectedMethod } = this.state;
    return (
      <div>
        <p>Choose Verification Method</p>
        <Radio.Group
          onChange={this.handleMethodChange}
          value={selectedMethod}
          className={styles.method_selector}
        >
          <Radio value={TWO_FA_METHODS.AUTHY}>Authy</Radio>
        </Radio.Group>
      </div>
    );
  };

  renderQR = () => {
    const { qrCode } = this.props;
    if (!qrCode) return null;
    return (
      <div className={styles.qr_code_container}>
        <p>Open Authy and scan this QR code</p>
        <div
          className={styles.code}
          dangerouslySetInnerHTML={{ __html: qrCode }}
        />
      </div>
    );
  };

  renderPin = () => {
    const { pin } = this.state;
    return (
      <div>
        <p>Verify Authy Authenticator</p>
        <p>Enter a code from Authy to make sure everything works.</p>
        <Input
          data-testid={'input1001'}
          autoFocus
          value={pin}
          className={styles.pin_input}
          placeholder="Authentication Code"
          onChange={this.handlePinChange}
        />
      </div>
    );
  };

  renderDone = () => {
    return (
      <div>
        <p>Verified</p>
        <p>From now on you’ll use Authy to sign in to SilentPush.</p>
        <img className={styles.icon} src={check_icon} alt="done" />
      </div>
    );
  };

  render() {
    const { step, showError } = this.state;
    const { status } = this.props;
    const isLoading = status === STATUS.LOADING;
    const isNextEnabled = this.canProceed();

    return (
      <Modal
        title="Set Up Two Factor Authentication Method"
        className={styles.container}
        visible
        onCancel={this.props.onCancel}
        footer={[
          <Button key="cancel" onClick={this.props.onCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={!isNextEnabled}
            onClick={this.handleSubmit}
          >
            {step === STEPS.DONE ? 'Done' : 'Next'}
          </Button>,
        ]}
      >
        {isLoading && !showError && <Spin className={styles.loader} />}
        {!isLoading && !showError && (
          <>
            {step === STEPS.METHOD && this.renderMethodSelector()}
            {step === STEPS.QR_CODE && this.renderQR()}
            {step === STEPS.PIN_CODE && this.renderPin()}
            {step === STEPS.DONE && this.renderDone()}
          </>
        )}
        {showError &&
          showNotification(
            simpleErrorNotification({
              statusCode: 400,
              message: 'Pin code is invalid',
            }),
          )}
      </Modal>
    );
  }
}

export default TwoFAModal;
